import React, { useEffect, useState } from "react";
import { globalFileIcon } from "../../../axiosInstance";
import { OpenTextGet } from "../../server/OpenText";

const PopUp = ({ close, width, children }) => {
  useEffect(() => {
    document.body.classList.add("modal-open");
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, []);

  return (
    <div className="popup">
      <div className="popup-wrapper animated" style={{ width }}>
        {close && (
          <div onClick={close} className="close-popup">
            <img
              loading="lazy"
              src={globalFileIcon + "cross-popup.svg"}
              alt="close"
            />
          </div>
        )}
        <div className="children-popup">{children}</div>
      </div>
    </div>
  );
};

export default PopUp;

export const SystemMessagePopUp = ({ close, width, children }) => {
  const [isMassage, setIsMassage] = useState(false);
  const KIND = "loginMessage";

  useEffect(() => {
    OpenTextGet(KIND)
      .then((x) => setIsMassage(x.data.length > 0 ? true : false))
      .catch((e) => console.log("error", e));
  }, []);

  return isMassage ? (
    <div className="popup">
      <div
        className="popup-wrapper animated"
        style={{
          backgroundImage: `url(${globalFileIcon + "AlertBg.svg"})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100%",
          backgroundColor: "transparent",
          width: width,
          height: "450px",
        }}
      >
        {close ? (
          <div onClick={close} className="close-popup system">
            <img
              loading="lazy"
              src={globalFileIcon + "cross-popup.svg"}
              alt="close"
            />
          </div>
        ) : null}
        <div className="system-popup-child">{children}</div>
      </div>
    </div>
  ) : null;
};
